import { ReactNode } from "react";

import { ApplicationBarHeader } from "@impero-com/ui";

import { useNewMenu } from "../../org/navigation/useNewMenu";

import { ApplicationHeader, ApplicationHeaderProps } from "./applicationHeader";

interface OrgApplicationBarHeaderProps extends ApplicationHeaderProps {
    leading?: ReactNode;
    /**
     * The `ApplicationBarToolbar`, if the page has one.
     */
    children?: ReactNode;
}

export function OrgApplicationBarHeader({
    title,
    routerLinks,
    leading,
    children,
}: OrgApplicationBarHeaderProps) {
    const newMenu = useNewMenu();

    return (
        <ApplicationBarHeader variant={newMenu ? "flat" : "default"}>
            <ApplicationHeader
                title={title}
                routerLinks={routerLinks}
                leading={leading}
            />
            {children}
        </ApplicationBarHeader>
    );
}
